// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { ReturnOrder, returnOrderSchema } from '@/return-order/api/types';
import { z } from 'zod';

/**
 * Schema for validating the response from the cancel return order API endpoint.
 */
const cancelReturnOrderResponseSchema = z.object({
  data: returnOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Cancels an existing return order with the specified reason.
 *
 * @param returnOrderKey - The key of the return order to cancel
 * @param reason - The reason for cancellation
 * @returns The cancelled return order
 */
export async function cancelReturnOrder(
  returnOrderKey: string,
  reason: string
): Promise<ReturnOrder> {
  const url = `/v1/return-order/${returnOrderKey}/cancel`;
  const response = await api.post(url, { cancellationReason: reason });

  const { data } = await parseResponse(
    cancelReturnOrderResponseSchema,
    response.data,
    {
      schemaName: 'CancelReturnOrder',
      endpoint: url,
    }
  );
  return data;
}
